import React, { useState } from "react";
import { Link } from "react-router-dom";

const RSMobileMenu = ({ setMenuOpen, menuOpen, activeMenu }) => {
  const [home, setHome] = useState(false);
  const [services, setServices] = useState(false);
  const [blog, setBlog] = useState(false);

  return (
    <div className="container relative">
      <div className={menuOpen ? "mobile-menu-part open" : "mobile-menu-part"}>
        <div className="mobile-menu">
          <ul className="nav-menu">
            <li
              className={
                home
                  ? "menu-item-has-children current-menu-item"
                  : "menu-item-has-children"
              }
            >
              <Link
                to="/"
                onClick={() => {
                  setMenuOpen(false);
                }}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className={activeMenu === "/about" ? "active-menu" : ""}
                onClick={() => {
                  setMenuOpen(false);
                }}
              >
                About Us
              </Link>
            </li>
            <li
              className={
                services
                  ? "menu-item-has-children current-menu-item"
                  : "menu-item-has-children"
              }
            >
              <Link
                to="/service"
                onClick={() => {
                  setMenuOpen(false);
                }}
              >
                Services
              </Link>
            </li>

            <li
              className={
                blog
                  ? "menu-item-has-children current-menu-item"
                  : "menu-item-has-children"
              }
            >
              <a
                target="_blank"
                href="https://blog.techniajz.com/blogs"
                rel="noopener noreferrer"
              >
                Blog
              </a>
              {/* <ul className={blog ? "sub-menu current-menu" : "sub-menu"}>
								<li>
									<Link to="/blog" className={activeMenu === "/blog" ? "active-menu" : ""}>Blog</Link>
								</li>
								<li>
									<Link to="/blog/blog-details" className={activeMenu === "/blog-details" ? "active-menu" : ""}>Blog details</Link>
								</li>
							</ul> */}
            </li>
            <li>
              <Link
                to="/contact"
                className={activeMenu === "/contact" ? "active-menu" : ""}
                onClick={() => {
                  setMenuOpen(false);
                }}
              >
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default RSMobileMenu;
